import { SyncActionDisplayChild } from '@modules/shared/sync-center/models/sync-action-display-child';
import { SyncAction } from '@shared/models/sync/sync-action';

// Maps a synced child to its sync-center display child. Generic (label + state + string child id),
// so every resolver reuses it whatever the child type.
export const syncActionToDisplayChild = (action: SyncAction): SyncActionDisplayChild => ({
  label: action.object.label,
  childId: String(action.object.id),
  state: action.state,
  type: action.object.type,
});
